import { PROCESS } from "@/lib/content";
import Reveal from "@/components/landing/Reveal";

export default function Process() {
    return (
        <section
            id="process"
            data-testid="process-section"
            className="bg-pearl-soft py-32 md:py-44 relative"
        >
            <div className="max-w-[1200px] mx-auto px-6 md:px-12">
                <div className="max-w-[36rem]">
                    <Reveal>
                        <p className="eyebrow text-cacao/60 mb-8">
                            <span className="divider-line text-cacao/40 mr-4 align-middle" />
                            The Process
                        </p>
                    </Reveal>
                    <Reveal delay={120}>
                        <h2
                            data-testid="process-headline"
                            className="font-serif text-cacao text-[2.2rem] sm:text-[3rem] md:text-[3.8rem] leading-[1.05]"
                        >
                            Simple, from first conversation to{" "}
                            <em className="italic text-clay-deep">finished home.</em>
                        </h2>
                    </Reveal>
                </div>

                <ol
                    data-testid="process-steps"
                    className="mt-20 md:mt-28 relative grid grid-cols-1 md:grid-cols-2 gap-x-20 gap-y-16 md:gap-y-24"
                >
                    {PROCESS.map((step, i) => (
                        <Reveal
                            as="li"
                            key={step.n}
                            delay={i * 120}
                            className="relative pl-0"
                        >
                            <div className="flex items-baseline gap-6">
                                <span className="font-serif text-cacao/25 text-[3.6rem] md:text-[4.4rem] leading-none">
                                    {step.n}
                                </span>
                                <h3
                                    className="font-serif text-cacao text-[1.7rem] md:text-[2.2rem]"
                                    data-testid={`process-step-title-${i}`}
                                >
                                    {step.title}
                                </h3>
                            </div>
                            <p className="mt-5 text-cacao/75 text-[1rem] leading-[1.8] font-light max-w-[28rem]">
                                {step.body}
                            </p>
                        </Reveal>
                    ))}
                </ol>

                <Reveal delay={300}>
                    <div className="mt-20 md:mt-28 flex justify-center">
                        <a
                            href="#offer"
                            data-testid="process-cta"
                            className="btn-ghost"
                        >
                            Start with a discovery conversation
                        </a>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
